
import { Component, Prop, Vue } from "vue-property-decorator";
import { lectureService } from "@/service/api/LectureService";
import { exportExcel } from "@/util/ExcelUtil";

@Component({
  components: {
    ApexChart: () =>
      import(
        /* webpackChunkName : "ApexChart" */ "@/components/common/chart/ApexChart.vue"
      )
  }
})
export default class LectureResultSurvey extends Vue {
  @Prop()
  private lectureId!: string;
  private surveyExcelQuestionList: SurveyQuestion[] = [];
  private excelDataSet: SurveyExcelExportDataType[] = [];
  private excelCreateColum: any = [];

  private chartSurveyDataList: LectureChartSurveyData[] = [];
  private surveyChartQuestionList: SurveyQuestion[] = [];
  private surveySerius: number[] = [];

  public mounted() {
    this.getSurveyList();
  }

  private getSurveyList() {
    lectureService
      .retrieveLectureSurvey(this.lectureId)
      .subscribe((list: SurveyResultSetData[]) => {
        this.setChartData(list);
        this.setExcelData(list);
      });
  }

  private setChartData(surveyResultSetDataList: SurveyResultSetData[]): void {
    surveyResultSetDataList.forEach(surveyResultSetData => {
      if (!surveyResultSetData.surveyQuestion.containTextAnswerFlag) {
        if (
          !this.surveyChartQuestionList.some(
            surveyQuestion =>
              surveyQuestion.id === surveyResultSetData.surveyQuestion.id
          )
        ) {
          this.surveySerius = [];
          this.surveyChartQuestionList.push(surveyResultSetData.surveyQuestion);
          for (const i of surveyResultSetData.surveyQuestion
            .multipleChoiceQuestions) {
            this.surveySerius.push(0);
          }
          this.chartSurveyDataList.push(
            this.initSurveyChartExportDataType(surveyResultSetData)
          );
        } else {
          const surveyChartExportDataListIndex = this.chartSurveyDataList.findIndex(
            surveyChartExportData =>
              surveyChartExportData.surveyQuestion.id ===
              surveyResultSetData.surveyQuestion.id
          );

          this.addSurveyInSurveyChartExportDataType(
            surveyChartExportDataListIndex,
            surveyResultSetData
          );
        }
      }
    });
  }

  private setExcelData(surveyResultSetDataList: SurveyResultSetData[]): void {
    surveyResultSetDataList.forEach(surveyResultSetData => {
      if (
        !this.surveyExcelQuestionList.some(
          surveyQuestion =>
            surveyQuestion.id === surveyResultSetData.surveyQuestion.id
        )
      ) {
        this.surveyExcelQuestionList.push(surveyResultSetData.surveyQuestion);
      }

      const surveyExcelExportDataListIndex = this.excelDataSet.findIndex(
        surveyExcelExportData =>
          surveyExcelExportData.userId === surveyResultSetData.user.id
      );

      if (surveyExcelExportDataListIndex === -1) {
        this.excelDataSet.push(
          this.initSurveyExcelExportDataType(surveyResultSetData)
        );
      } else {
        this.addSurveyInSurveyExcelExportDataType(
          surveyExcelExportDataListIndex,
          surveyResultSetData
        );
      }
    });

    this.surveyExcelQuestionList.sort(
      (surveyQuestionA, surveyQuestionB) =>
        surveyQuestionA.order - surveyQuestionB.order
    );
  }

  private initSurveyChartExportDataType(
    surveyResultSetData: SurveyResultSetData
  ): LectureChartSurveyData {
    const iterator = surveyResultSetData.surveyResult.answer.values();
    for (const value of iterator) {
      this.surveySerius[value]++;
    }
    return {
      surveyQuestion: surveyResultSetData.surveyQuestion,
      surveySerius: this.surveySerius
    };
  }

  private addSurveyInSurveyChartExportDataType(
    index: number,
    surveyResultSetData: SurveyResultSetData
  ): void {
    const iterator = surveyResultSetData.surveyResult.answer.values();
    for (const value of iterator) {
      this.chartSurveyDataList[index].surveySerius[value]++;
    }
  }

  private initSurveyExcelExportDataType(
    surveyResultSetData: SurveyResultSetData
  ): SurveyExcelExportDataType {
    return {
      userId: surveyResultSetData.user.id,
      userName: surveyResultSetData.user.name,
      survey: [
        {
          order: surveyResultSetData.surveyQuestion.order,
          surveyId: surveyResultSetData.surveyQuestion.id,
          surveyTitle: surveyResultSetData.surveyQuestion.question,
          surveyAnswer: surveyResultSetData.surveyResult.answer,
          containTextAnswerFlag:
            surveyResultSetData.surveyQuestion.containTextAnswerFlag,
          multipleChoiceQuestions:
            surveyResultSetData.surveyQuestion.multipleChoiceQuestions,
          textAnswer: surveyResultSetData.surveyResult.textAnswer as string
        }
      ]
    };
  }

  private addSurveyInSurveyExcelExportDataType(
    index: number,
    surveyResultSetData: SurveyResultSetData
  ): void {
    this.excelDataSet[index].survey.push({
      order: surveyResultSetData.surveyQuestion.order,
      surveyId: surveyResultSetData.surveyQuestion.id,
      surveyTitle: surveyResultSetData.surveyQuestion.question,
      surveyAnswer: surveyResultSetData.surveyResult.answer,
      containTextAnswerFlag:
        surveyResultSetData.surveyQuestion.containTextAnswerFlag,
      multipleChoiceQuestions:
        surveyResultSetData.surveyQuestion.multipleChoiceQuestions,
      textAnswer: surveyResultSetData.surveyResult.textAnswer as string
    });
  }

  private exportExcel() {
    this.excelCreateColum = [];
    this.excelDataSet.forEach((value, index: number) => {
      const jsonData: any = {
        ["no"]: index,
        ["이름"]: value.userName
      };
      this.excelDataSet[index].survey.forEach((survey: SurveyResultData) => {
        if (survey.containTextAnswerFlag) {
          jsonData[survey.surveyTitle] = survey.textAnswer;
        } else {
          jsonData[survey.surveyTitle] =
            survey.multipleChoiceQuestions[survey.surveyAnswer[0]];
        }
      });
      this.excelCreateColum.push(jsonData);
    });
    const jsonData: { [key: string]: string | number } = {
      ["no"]: "평점",
      ["이름"]: ""
    };
    for (let i = 0; i < this.surveyExcelQuestionList.length; i++) {
      if (
        !this.surveyExcelQuestionList[i].multipleChoiceFlag &&
        !this.surveyExcelQuestionList[i].containTextAnswerFlag
      ) {
        jsonData[this.surveyExcelQuestionList[i].question] = (
          this.excelDataSet.reduce(
            (score: number, data: SurveyExcelExportDataType) => {
              const surveyIndex = data.survey.findIndex(
                (survey: SurveyResultData) =>
                  survey.surveyId === this.surveyExcelQuestionList[i].id
              );
              return surveyIndex !== -1 &&
                data.survey[surveyIndex].surveyAnswer.length > 0
                ? this.surveyExcelQuestionList[surveyIndex]
                    .multipleChoiceQuestions.length -
                    data.survey[surveyIndex].surveyAnswer[0] +
                    score
                : score;
            },
            0
          ) / this.excelDataSet.length
        ).toFixed(1);
      }
    }

    this.excelCreateColum.push(jsonData);
    exportExcel(this.excelCreateColum, "result", "result.xlsx");
  }

  private get textAnswerQuestionList(): SurveyQuestion[] {
    return this.surveyExcelQuestionList.filter(
      surveyQuestion => surveyQuestion.containTextAnswerFlag
    );
  }

  private textAnswerList(surveyQuestion: SurveyQuestion): string[] {
    return this.excelDataSet
      .map((data: SurveyExcelExportDataType) => {
        const surveyIndex = data.survey.findIndex(
          survey => survey.surveyId === surveyQuestion.id
        );
        return surveyIndex === -1 ? "" : data.survey[surveyIndex].textAnswer;
      })
      .flat()
      .filter(text => text.length > 0);
  }
}
